var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property-mls-sponsor-logo"},[(_vm.logoSrc)?_c('div',{staticClass:"organization-logo"},[_c('avatar',{staticClass:"organization-logo-avatar",attrs:{"src":_vm.logoSrc,"size":_vm.avatarSize}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }